import { clearCache, noteFonctions } from "./tools/listCache";

const webDbName = "";
const webUrlAgent = "echangeur";
class Action {
  constructor(fonction, parametres, i, o, d) {
    this.echangeur = null;
    this.a = null;
    this.f = fonction;
    this.p = parametres;
    this.i = i;
    this.o = o;
    this.d = d;
  }
  clone() {
    return new Action(this.f, this.p, this.i, this.o, this.d);
  }
  setInput(data, echangeur) {
    if (!this.i) return this;
    echangeur = echangeur || this.echangeur;
    var tn = this.i.split(".");
    if (tn.length == 2) {
      if (!echangeur[tn[0]]) echangeur[tn[0]] = {};
      var x = echangeur[tn[0]];
      x[tn[1]] = data;
    } else if (tn.length == 1) {
      echangeur[tn[0]] = data;
    }
  }
  getInput() {
    var tn = this.i.split(".");
    var x = this.echangeur[tn[0]];
    if (tn.length == 2) {
      return !x ? null : x[tn[1]];
    } else if (tn.length == 1) {
      return this.echangeur[tn[0]];
    }
  }
}

class Echangeur {
  constructor(name) {
    this.name = name;
    this.actions = [];
    this.hash = null;
  }
  set(key, value) {
    this[key] = value;
  }
  get(key) {
    return this[key];
  }
  pushAction(action) {
    this.actions.push(action);
  }
  addAction(fonction, parametres, i, o, d) {
    this.actions.push(new Action(fonction, parametres, i, o, d));
    return this;
  }
  clone() {
    // d destination de la requete
    //
    var echangeurServeur = new Echangeur(this.name);
    //
    if (this.hash) echangeurServeur.hash = this.hash;
    //
    for (const action of this.actions) {
      action.echangeur = this;
      var actionServeur = action.clone();
      echangeurServeur.pushAction(actionServeur);
      actionServeur.setInput(action.getInput(), echangeurServeur);
    }
    return echangeurServeur;
  }
  // Logout, post /logout au serveur qui effectue un session.destroy;
  static async logout() {
    // Les listes gardées en mémoire ne doivent pas être montrées à l'utilisateur suivant
    clearCache();
    const url = "/logout";
    const settings = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    };
    let fetchResponse = await fetch(url, settings);

    return fetchResponse;
  }

  async runAsync(param) {
    if (!this.actions.length) return;
    if (this.erreur) delete this.erreur;
    if (!param) param = {};
    //
    let query = window.location.href.split("#")[0];
    query = query.indexOf("?") >= 0 ? query.substring(query.indexOf("?")) : "";
    //
    let p3 = "t" + new Date().getTime();
    //
    const echangeur = this.clone();
    //
    if (echangeur.actions.length) {
      // Une modification vide le cache des listes (avant l'envoi, et après la réponse pour écarter
      // les listes demandées pendant qu'elle était en cours)
      const fonctions = echangeur.actions.map((a) => a.f);
      noteFonctions(fonctions);
      const url = webDbName + webUrlAgent + "/" + p3 + query;
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(echangeur),
      };

      let fetchResponse = await fetch(url, settings);

      if (fetchResponse.status == 401) {
        // Session expirée : un autre utilisateur peut se reconnecter dans cet onglet
        clearCache();
        if (param.nomodal) {
          // on fait rien
        } else {
          await window.onError401();
          fetchResponse = await fetch(url, settings);
        }
      }

      let donnee = await fetchResponse.json();
      noteFonctions(fonctions);
      for (var i in donnee.$outputs)
        this[donnee.$outputs[i]] = donnee[donnee.$outputs[i]];
      if (donnee.erreur) {
        this.erreur = donnee.erreur;
      } else {
        delete this.erreur;
      }
    }
    //
    return this;
  }
  // Appel type rest d'un Echangeur qui contient une action unique.
  static async rest(fonction, parametres, doc, d) {
    const echangeur = new Echangeur("rest " + fonction);
    echangeur.set("doc", doc);
    echangeur.addAction(fonction, parametres, "doc", "output", d);
    const v = await echangeur.runAsync();
    if (!v) throw "Echangeur is nothing";
    if (v.erreur) throw v.erreur;
    return v.get("output");
  }
  // Appel type rest d'un Echangeur qui contient une action unique sans appel au modal.
  static async restnomodal(fonction, parametres, doc, d) {
    const echangeur = new Echangeur("rest " + fonction);
    echangeur.set("doc", doc);
    echangeur.addAction(fonction, parametres, "doc", "output", d);
    const v = await echangeur.runAsync({ nomodal: true });
    if (!v) throw "Echangeur is nothing";
    if (v.erreur) throw v.erreur;
    return v.get("output");
  }
}

export { Echangeur };
